import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewCustomerFeedback } from './customer-feedback.types';

@Injectable({
  providedIn: 'root'
})
export class CustomerFeedbackService {
  hostUrl = 'https://appgw.prod.iktest.co';
  appApiUrl = `${this.hostUrl}/api-app`;

  constructor(private _httpClient: HttpClient) {}

  postFeedbackAnalysisFeature(feedback: NewCustomerFeedback) {
    return this._httpClient.post<NewCustomerFeedback>(
      `${this.appApiUrl}/me/customer-feedback/analysis-feature`,
      feedback
    );
  }

  postFeedbackApp(feedback: NewCustomerFeedback) {
    return this._httpClient.post<NewCustomerFeedback>(
      `${this.appApiUrl}/me/customer-feedback/app`,
      feedback
    );
  }
}
